document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('#MainNav');
  toggle?.addEventListener('click', () => {
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    nav?.classList.toggle('is-open', !open);
  });

  const cards = [...document.querySelectorAll('[data-product-card]')];
  const search = document.querySelector('[data-catalog-search]');
  search?.addEventListener('input', () => {
    const query = search.value.trim().toLowerCase();
    cards.forEach((card) => {
      const matches = !query || card.textContent.toLowerCase().includes(query);
      card.hidden = !matches;
    });
  });
  document.querySelectorAll('[data-filter]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('[data-filter]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
      const filter = button.dataset.filter;
      cards.forEach((card) => card.hidden = filter !== 'all' && !card.dataset.tags.includes(filter));
    });
  });

  document.querySelector('[data-sort]')?.addEventListener('change', (event) => {
    const grid = document.querySelector('[data-product-grid]');
    if (!grid || event.target.value === 'featured') return;
    [...grid.querySelectorAll('[data-product-card]')]
      .sort((a, b) => {
        const left = a.querySelector('h3')?.textContent.trim() || '';
        const right = b.querySelector('h3')?.textContent.trim() || '';
        return event.target.value === 'az' ? left.localeCompare(right) : right.localeCompare(left);
      })
      .forEach((card) => grid.appendChild(card));
  });

  document.querySelectorAll('.quick-add').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button');
    button.disabled = true; button.textContent = 'Adding…';
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }});
      if (!response.ok) throw new Error('Unable to add');
      const cart = await fetch('/cart.js').then((r) => r.json());
      document.querySelector('[data-cart-count]').textContent = cart.item_count;
      button.textContent = 'Added ✓';
    } catch { button.textContent = 'Try again'; }
    finally { setTimeout(() => { button.disabled = false; button.textContent = 'Pre-order'; }, 1600); }
  }));

  const carousel = document.querySelector('[data-hero-carousel]');
  if (carousel) {
    const slides = [...carousel.querySelectorAll('[data-hero-slide]')];
    const dots = [...carousel.querySelectorAll('[data-hero-dot]')];
    let active = 0;
    let timer;
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
    };
    const restart = () => {
      window.clearInterval(timer);
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(active + 1), 5000);
    };
    carousel.querySelector('[data-hero-prev]')?.addEventListener('click', () => { show(active - 1); restart(); });
    carousel.querySelector('[data-hero-next]')?.addEventListener('click', () => { show(active + 1); restart(); });
    dots.forEach((dot, index) => dot.addEventListener('click', () => { show(index); restart(); }));
    carousel.addEventListener('mouseenter', () => window.clearInterval(timer));
    carousel.addEventListener('mouseleave', restart);
    restart();
  }
});
